const infoConstants = {
  nhsEmail: "Support@pharmacaregroup.co.uk",
  nhsPhoneNumber: "0330 043 0908",
};

export default infoConstants;
